import { useLocation } from "react-router-dom";
import { Folder, ArrowLeftIcon, ChevronDown } from "lucide-react";
import { SidebarGroupContent } from "@/shared/components/ui/Sidebar";
import { useAppSelector, useAppDispatch } from "@/redux/store";
import { setCategoryFilterValue } from "@/redux/slices/filterSlice";
import { useEffect } from "react";
import clsx from "clsx";
import {
	SidebarMenuButton,
	SidebarMenuSub,
	SidebarMenuSubButton,
	SidebarMenuSubItem,
} from "@/shared/components/ui/Sidebar";
import * as CollapsiblePrimitive from "@radix-ui/react-collapsible";

const categories = [
	{ id: "DESIGN", name: "DESIGN" },
	{ id: "EMAIL", name: "EMAIL" },
	{ id: "DISPLAY", name: "DISPLAY" },
	{ id: "RETARGET", name: "RETARGET" },
	{ id: "SOCIAL", name: "SOCIAL" },
	{ id: "VIDEO", name: "VIDEO" },
	{ id: "ADMIN", name: "ADMIN" },
	{ id: "COMMUNICATION", name: "COMMUNICATION" },
	{ id: "ORDER", name: "ORDER" },
	{ id: "AGENCY_COLLATERAL", name: "AGENCY COLLATERAL" },
	{ id: "REPORT", name: "REPORT" },
];

// Custom category menu component
export function CategoryMenu() {
	const dispatch = useAppDispatch();
	const categoryFilterValue = useAppSelector(state => state.filter.categoryFilterValue);

	// Check if any category is active
	// const isActive = categories.some(category => categoryFilterValue === category.id);

	return (
		<CollapsiblePrimitive.Collapsible className="group/collapsible" defaultOpen={true}>
			<CollapsiblePrimitive.CollapsibleTrigger className="flex w-full items-center justify-between gap-1 pb-1">
				<SidebarMenuButton asChild>
					<span>
						<Folder size={15} className="mr-2" />
						<span>Folders</span>
					</span>
				</SidebarMenuButton>
				<ChevronDown className="ml-auto transition-transform group-data-[state=open]/collapsible:rotate-180" />
			</CollapsiblePrimitive.CollapsibleTrigger>
			<CollapsiblePrimitive.CollapsibleContent>
				<SidebarMenuSub>
					{categories.map(category => {
						const isCategorySelected = categoryFilterValue === category.id;

						return (
							<SidebarMenuSubItem key={category.id}>
								<SidebarMenuSubButton asChild>
									<button
										onClick={e => {
											e.preventDefault();
											dispatch(setCategoryFilterValue(category.id));
										}}
										className={clsx("flex w-full items-center rounded-md px-2 py-2 text-sm transition-colors", {
											"bg-[#004F8D] text-white hover:bg-[#004F8D]": isCategorySelected,
											"hover:bg-blue-780": !isCategorySelected,
										})}
									>
										<span className="ml-6">{category.name}</span>
									</button>
								</SidebarMenuSubButton>
							</SidebarMenuSubItem>
						);
					})}
				</SidebarMenuSub>
			</CollapsiblePrimitive.CollapsibleContent>
		</CollapsiblePrimitive.Collapsible>
	);
}

// Custom category menu component
// const CategoryMenu = () => {
//     const dispatch = useAppDispatch();
//     const categoryFilterValue = useAppSelector(state => state.filter.categoryFilterValue);

//     // Check if any category is active
//     // const isActive = categories.some(category => categoryFilterValue === category.id);

//     return (
//         <CollapsiblePrimitive.Collapsible className="group/collapsible" defaultOpen={true}>
//             <CollapsiblePrimitive.CollapsibleTrigger className="flex w-full items-center justify-between gap-1 pb-1">
//                 <SidebarMenuButton asChild>
//                     <span>
//                         <Folder size={15} className="mr-2" />
//                         <span>Folders</span>
//                     </span>
//                 </SidebarMenuButton>
//                 <ChevronDown className="ml-auto transition-transform group-data-[state=open]/collapsible:rotate-180" />
//             </CollapsiblePrimitive.CollapsibleTrigger>
//             <CollapsiblePrimitive.CollapsibleContent>
//                 <SidebarMenuSub>
//                     {categories.map(category => {
//                         const isCategorySelected = categoryFilterValue === category.id;

//                         return (
//                             <SidebarMenuSubItem key={category.id}>
//                                 <SidebarMenuSubButton asChild>
//                                     <button
//                                         onClick={e => {
//                                             e.preventDefault();
//                                             dispatch(setCategoryFilterValue(category.id));
//                                         }}
//                                         className={clsx("flex w-full items-center rounded-md px-2 py-2 text-sm transition-colors", {
//                                             "bg-[#004F8D] text-white hover:bg-[#004F8D]": isCategorySelected,
//                                             "hover:bg-blue-780": !isCategorySelected,
//                                         })}
//                                     >
//                                         <span className="ml-6">{category.name}</span>
//                                     </button>
//                                 </SidebarMenuSubButton>
//                             </SidebarMenuSubItem>
//                         );
//                     })}
//                 </SidebarMenuSub>
//             </CollapsiblePrimitive.CollapsibleContent>
//         </CollapsiblePrimitive.Collapsible>
//     );
// };

export function AssetSideBar() {
	const location = useLocation();
	const dispatch = useAppDispatch();
	const queryParams = new URLSearchParams(location.search);
	const urlCategory = queryParams.get("category");

	// Sync URL category with state when component mounts (only once)
	useEffect(() => {
		if (urlCategory) {
			const isValidCategory = categories.some(cat => cat.id === urlCategory);
			if (isValidCategory) {
				dispatch(setCategoryFilterValue(urlCategory));
			}
		}
	}, [urlCategory, dispatch]);

	return (
		<SidebarGroupContent>
			{/* Dashboard Button */}
			<SidebarMenuButton asChild>
				<a
					href="/agency-order/order-listing"
					className={clsx(location.pathname === "/agency-order/order-listing" ? "bg-blue-600 text-white" : "")}
				>
					<ArrowLeftIcon />
					<span>Back to order listing</span>
				</a>
			</SidebarMenuButton>

			<div className="mt-12">
				<CategoryMenu />
			</div>
		</SidebarGroupContent>
	);
}
